import useIdPagination from "@js2/hooks/useIdPagination";
import type { Domain } from "@modules/network/@types/Domain";
import NetworkThreatCard from "@modules/network/components/cards/NetworkThreatCard";
import CardTitle from "@modules/network/components/common/CardTitle";
import NetworkThreatNoDataMsg from "@modules/network/components/common/NetworkThreatNoDataMsg";
import useEnrichedPassiveDns from "../hooks/useEnrichedPassiveDns";
import PassiveDnsTable from "../resolutions/PassiveDnsTable";

const PAGE_SIZE = 5;

const PassiveDnsCard = ({ domain }: Domain) => {
  const {
    currentPageId: page,
    prevPageId,
    pageSize,
    onPaginationChange
  } = useIdPagination("", PAGE_SIZE);
  const { data, isLoading, isFetching } = useEnrichedPassiveDns({
    domain,
    page,
    page_size: pageSize
  });

  return (
    <NetworkThreatCard
      showError={!data?.resolutions?.length && !isLoading}
      errorComp={
        <NetworkThreatCard.Error>
          <NetworkThreatNoDataMsg />
        </NetworkThreatCard.Error>
      }
      header={
        <NetworkThreatCard.Header
          title={
            <CardTitle
              label="Passive DNS"
              hint="Shown data represents historical DNS records. Last seen represents time when the record was last resolved."
            />
          }
          headerLinkComp={
            <div className="flex align-center h-100">
              <NetworkThreatCard.PageIdNavigation
                disabled={isFetching}
                prev={prevPageId}
                next={data?.next_page ?? ""}
                onClick={onPaginationChange}
                data-testid="domain-passive-dns-pagination"
              />
            </div>
          }
        />
      }
      content={
        <PassiveDnsTable data={data?.resolutions || []} isLoading={isLoading} />
      }
    />
  );
};

export default PassiveDnsCard;
